function fillZeros(amount: number) {
  return Array(Math.max(0, amount)).fill(0).join('');
}

function fillThousandsZeros(value: number) {
  const stringValue = String(value);
  return `${fillZeros(3 - stringValue.length)}${String(value)}`;
}

const decimalCount = Number(window.AMOUNT_DECIMAL_SEPARATOR);
const decimalZeros = Number(window.AMOUNT_DECIMAL_ZEROS);
const decimalSeparator = window.CHAR_DECIMAL_SEPARATOR;
const thousandsSeparator = window.CHAR_THOUS_SEPARATOR;
const regexpThousandsSeparator =
  thousandsSeparator === '.' ? '\\.' : thousandsSeparator;
const regexpDecimalSeparator =
  decimalSeparator === '.' ? '\\.' : decimalSeparator;
const shouldRound = false;

/* 
function parseNumberInputValueToNumber(value: string): number {
  return Number.parseFloat(
    value.replaceAll(thousandsSeparator, '').replaceAll(decimalSeparator, '.'),
  );
}

function parseNumberValueToNumberInput(value: string | number): string {
  const stringNumber = String(value);
  const result = stringNumber.match(/(-?)(\d+)(?:\.(\d+))?/);
  if (!result) return '';

  const isNegative = !!result[1];
  const integer = result[2];
  const decimals = result[3] as string | null;
  const decimalsString = decimals ? `${regexpDecimalSeparator}${decimals}` : '';

  return (
    parseStringToApiaNumber(
      `${isNegative ? '-' : ''}${integer}${decimalsString}`,
    ) ?? ''
  );
} */

export function parseStringToApiaNumber(value: string): string | null {
  const result = value.match(
    new RegExp(
      `^(-)?((?:(?:\\d{1,3})${regexpThousandsSeparator}(?:\\d{3}${regexpThousandsSeparator})*(?:\\d{3}))?|(?:\\d*))(?:(?:${regexpDecimalSeparator})(\\d+))?$`,
    ),
  );
  if (!result) return null;

  const isNegative = !!result[1];
  let module = Number(result[2].replaceAll(thousandsSeparator, ''));
  const slicedDecimals = result[3]?.slice(0, decimalCount + 1) ?? '';
  const noZeroDecimals =
    (slicedDecimals
      ? `${String(
          Math.round(
            Number(
              `${slicedDecimals}${fillZeros(
                (shouldRound ? decimalCount + 1 : decimalCount) -
                  slicedDecimals.length,
              )}`,
            ) / (shouldRound ? 10 : 1),
          ),
        )}`
      : ''
    )
      .slice(0, decimalCount)
      .match(/(\d*[1-9])0*/)?.[1] ?? '';

  const decimalsString: string = `${noZeroDecimals}${fillZeros(
    decimalZeros - noZeroDecimals.length,
  )}`;

  const finalNumberString: string[] = [];
  while (module >= 1000) {
    module /= 1000;
    const truncedInteger = Math.trunc(module);
    finalNumberString.unshift(
      fillThousandsZeros(Math.round((module - truncedInteger) * 1000)),
    );
    module = truncedInteger;
  }
  finalNumberString.unshift(String(module));

  return `${isNegative ? '-' : ''}${finalNumberString.join(
    window.ADD_THOUSAND_SEPARATOR ? window.CHAR_THOUS_SEPARATOR : '',
  )}${decimalsString.length > 0 ? `${decimalSeparator}${decimalsString}` : ''}`;
}
